"use strict";

import Vue from 'vue'

// 将动态表单调用注册到全局，每个vue文件都可以用 this.$dyform.dispose('user','loadUser',{id:22}).then((res)=>{})
const _dyform = {
  /**
   * 动态表单统一调用函数
   * @param {*} path 路径 子目录用中划线  如test-user
   * @param {*} key datasource key
   * @param {*} params 传参数
   */
  dispose: function (path, key, params) {
    //console.log("传入的参数为:{}" , params)
    const formData = new FormData()
    if(Array.isArray(params)){
      //console.log("传入的参数为数组")
      //单表数据示例:[{id:'',name:'test1'},{id:'',name:'test2'}]
      //多表数据示例:[{parent:{id:'',name:'parentName'},child:[{id:'',name:'childName1',parentId:'{parent.id}'},{id:'',name:'childName2',parentId:'{parent.id}'}]}]
      for( var i = 0; i < params.length; i++){//循环数组
        var flag = false;
        for( var key2 in params[i]){//如果对象中value值为数组,则判断为多表情况
          if(Array.isArray(params[i][key2] && ('child' === key2))){
            flag = true;
          }
        }
        for( var key2 in params[i]){
          var value = params[i][key2]
          if(flag){//flag为true则判断为多表情况
            if(Array.isArray(value)){//多表情况下,如果value值为数组,则循环数组取值
              for(var j = 0; j < value.length; j++){
                for (var key3 in value[j]){
                  formData.append(key2 + "." + key3 , value[j][key3])
                }
              }
            }else{//多表情况下,如果value值为对象,则迭代对象取值
              for (var key3 in value){
                formData.append(key2 + "." + key3 , (value[key3] === null || value[key3] === undefined) ? '' : value[key3])
              }
            }
          }else{//flag为false则判断为单表情况,直接从对象中取值
            if (Array.isArray(value)) {
              for (var j = 0; j < value.length; j++) {
                formData.append(key2, value[j])
              }
            } else {
              formData.append(key2, (value === null || value === undefined) ? '' : value)
            }
          }
        }
      }
    }else{
      //console.log("传入的参数为对象")
      for (var key1 in params) {
        var val = params[key1]
        if (Array.isArray(val)) {
          for (var i = 0; i < val.length; i++) {
            formData.append(key1, val[i])
          }
        } else {
          formData.append(key1, (val === null || val === undefined) ? '' : val)
        }
      }
    }






    return Vue.axios({
      url: '/api/' + path + '/' + key + '.do',
      method: 'post',
      data: formData
    })
  },
  disposeFileData: function (path, key, params, fileUploadParams,func){
    var fileUploadPath = 'file-minFile'
    var fileUploadKey = 'uploadList'
    this.dispose(path, key, params).then( (response) => {
      if (response.data && response.data.success) {
        var newParams
        var flag = false
        if(Array.isArray(fileUploadParams)){
          newParams = new Array(fileUploadParams.length)
          for (var i = 0; i < fileUploadParams.length; i++) {
            if(fileUploadParams[i].path && fileUploadParams[i].path.length > 0){
              var category = []
              var type = []
              for(var j = 0; j < fileUploadParams[i].path.length; j++){
                category.push(fileUploadParams[i].category)
                type.push(fileUploadParams[i].type)
              }
              newParams[i] = Object.assign({}, {path: fileUploadParams[i].path, category: category, type: type, bizId: response.data.id})
            }
          }
          if(newParams[0]){
            flag = true
          }
        }else{
          newParams = Object.assign({}, fileUploadParams, {bizId: response.data.id})
          if(fileUploadParams.path && fileUploadParams.path.length > 0){
            flag = true
          }
        }
        if(flag){
          this.dispose(fileUploadPath, fileUploadKey, newParams).then(function (response) {
            func(response)
          })
        }else{
          func(response)
        }
      }else{
        func(response)
      }
    })
  }

}

// 安装组件
const plugin = {
  install(Vue, options) {
    Vue.dyform = _dyform;
    window.dyform = _dyform;
    Object.defineProperties(Vue.prototype, {
      dyform: {
        get() {
          return _dyform;
        }
      },
      $dyform: {
        get() {
          return _dyform;
        }
      },
    });
  }
}

Vue.use(plugin)

export default plugin;
